export default "__VITE_ASSET__pUcRXgD9__"